import { allSubscriptionsVar } from '@/graphql/state';
import { useReactiveVar } from '@apollo/client';
import { useMemo } from 'react';

export const useSubscriptionsIds = (): number[] => {
  const allSubscriptions = useReactiveVar(allSubscriptionsVar);
  const schoolIds = useMemo(() => allSubscriptions.map(sub => Number(sub.id)), []);
  return schoolIds;
};
